module.exports = __webpack_public_path__ + "static/media/42x42-8.e4c63ba5.png";